import React from "react";
import ScrollbarComponentItems from "./ScrollbarComponentItems";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  scrollBar: (props) => ({
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: props.trackColor || "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: props.thumbColor || "#888",
      borderRadius: props.borderRadius || "0px",
    },
  }),
}));
const ScrollbarContent = ({
  items,
  editComponent,
  toggleAnimatedBanner,
  isAspectRatioLocked,
  onDropScrollbar,
  layerCompData,
  setLayerCompData,
  onDragOverScrollbar,
  setScrollbarItems,
  playPause,
  canvasDimension,
  isDragged,
  froalaEditorHandleOnclciksAndDrag,
  setFroalaIndex,
  setContainerID,
  index,
  createFroalaInstance,
  handleScrollbarComponentsDrag,
  handleScrollbarComponentsDragStop,
  Scrollbars,
  parse,
  handleCallonResizeStop,
  setCurrentIdZindex,
  sendSelectedComponent,
  selectedComponent,
  layerIndex,
  FroalaEditor,
  setIsEditorOnScrollbarItems,
  isEditorOnScrollbarItems,
  playPauseRef,
  handleCallonResize,
  handleTextChangeInScrollComp,
  handleCtrlClick,
  scrollBarExpand,
  setDisplayColorPicker,
  setVisibility,
  handleDeleteKey,
  setSelectedComponent,
  setMultiSelectedComps,
}) => {
  let trackColor = items.componentStyles?.scrollThumbBgColor;
  let thumbColor = items.componentStyles?.scrollThumbColor;
  let borderRadius = items.componentStyles?.scrollBorderRadius;
  let showArrows = true;
  const classes = useStyles({
    trackColor,
    thumbColor,
    borderRadius,
    showArrows,
  });
  return (
    <div
      className={classes.scrollBar}
      style={
        editComponent === items.id
          ? {}
          : {
              width: "100%",
              height: `${items.componentStyles.height}px`,
              overflowY: "scroll",
              overflowX: "hidden",
              pointerEvents: items?.componentStyles?.hideBoolean ? "none" : "",
              backgroundColor: items.componentStyles.backgroundColor,
              paddingTop: items.componentStyles.paddingTop,
              paddingRight: items.componentStyles.paddingRight,
              paddingBottom: items.componentStyles.paddingBottom,
              paddingLeft: items.componentStyles.paddingLeft,
              borderTopLeftRadius: items.componentStyles.borderTopLeftRadius,
              borderTopRightRadius: items.componentStyles.borderTopRightRadius,
              borderBottomLeftRadius:
                items.componentStyles.borderBottomLeftRadius,
              borderBottomRightRadius:
                items.componentStyles.borderBottomRightRadius,
              transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
              transform: items.componentStyles.scale,
              aspectLock: isAspectRatioLocked,
            }
      }
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: `${items.componentStyles.scrollbarHeight}px`,
          backgroundColor:
            editComponent === items.id
              ? items.componentStyles.backgroundColor
              : "transparent",
          border: `${editComponent === items.id ? "2px solid #4CAF50" : ""}`,
          paddingTop: items.componentStyles.paddingTop,
          paddingRight: items.componentStyles.paddingRight,
          paddingBottom: items.componentStyles.paddingBottom,
          paddingLeft: items.componentStyles.paddingLeft,
          borderTopLeftRadius: items.componentStyles.borderTopLeftRadius,
          borderTopRightRadius: items.componentStyles.borderTopRightRadius,
          borderBottomLeftRadius: items.componentStyles.borderBottomLeftRadius,
          borderBottomRightRadius:
            items.componentStyles.borderBottomRightRadius,
          transform: `rotate(${items.componentStyles.rotation}) scale(${items.componentStyles.scale})`,
          aspectLock: isAspectRatioLocked,
          overflow: "hidden",
          zIndex: "auto",
          // Block nested hit-testing until scrollbar is in edit mode.
          pointerEvents: editComponent === items.id ? "auto" : "none",
        }}
        onMouseUp={(e) => {}}
        onDrop={(e) => {
          editComponent === items.id && onDropScrollbar(e, items.id);
        }}
        onDragOver={(e) => {
          editComponent === items.id && onDragOverScrollbar(e, items.id);
        }}
      >
        <ScrollbarComponentItems
          id={items.id}
          layerCompData={layerCompData}
          setLayerCompData={setLayerCompData}
          setScrollbarItems={setScrollbarItems}
          scrollbarItems={items.scrollbarComponents}
          playPause={playPause}
          setIsEditorOn={setIsEditorOnScrollbarItems}
          isEditorOn={isEditorOnScrollbarItems}
          canvasDimension={canvasDimension}
          isDragged={isDragged}
          froalaEditorHandleOnclciksAndDrag={froalaEditorHandleOnclciksAndDrag}
          setFroalaIndex={setFroalaIndex}
          setContainerID={setContainerID}
          index={index}
          Scrollbars={Scrollbars}
          createFroalaInstance={createFroalaInstance}
          parse={parse}
          playPauseRef={playPauseRef}
          isAspectRatioLocked={isAspectRatioLocked}
          handleComponentsDrag={handleScrollbarComponentsDrag}
          handleComponentsDragStop={handleScrollbarComponentsDragStop}
          updateFontOnResize={handleCallonResize}
          callOnResizeStop={handleCallonResizeStop}
          setCurrentIdZindex={setCurrentIdZindex}
          sendSelectedComponent={sendSelectedComponent}
          selectedComponent={selectedComponent}
          layerIndex={layerIndex}
          FroalaEditor={FroalaEditor}
          handleTextChangeInLayerComp={handleTextChangeInScrollComp}
          handleCtrlClick={handleCtrlClick}
          scrollBarExpand={scrollBarExpand}
          setDisplayColorPicker={setDisplayColorPicker}
          setVisibility={setVisibility}
          handleDeleteKey={handleDeleteKey}
          toggleAnimatedBanner={toggleAnimatedBanner}
          scrollbarContainerHeight={items.componentStyles.scrollbarHeight}
          scrollbarContainerWidth={items?.componentStyles?.width}
          setSelectedComponent={setSelectedComponent}
          setMultiSelectedComps={setMultiSelectedComps}
          editComponent={editComponent}
        />
      </div>
    </div>
  );
};
export default ScrollbarContent;
